import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import React from "react";
var __jsx = React.createElement;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Localize from '~/common/Localize';
import LocalizedTime from '~/components/LocalizedTime';
import { Body1, Container, Theme, themed } from '~/styles/Theme';
var OpeningHoursItem = /*#__PURE__*/function (_Component) {
  _inherits(OpeningHoursItem, _Component);
  var _super = _createSuper(OpeningHoursItem);
  function OpeningHoursItem() {
    var _this;
    _classCallCheck(this, OpeningHoursItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderDay", function () {
      return 'home.day.' + _this.props.day;
    });
    return _this;
  }
  _createClass(OpeningHoursItem, [{
    key: "render",
    value: function render() {
      return __jsx(DayContainer, null, __jsx(DayLabel, null, Localize(this.renderDay())), __jsx(TimeContainer, null, __jsx(TimeLabelStart, {
        adjustsFontSizeToFit: true,
        numberOfLines: 1
      }, __jsx(LocalizedTime, {
        parse: 'HH:mm',
        format: 'LT'
      }, this.props.startTime)), __jsx(TimeDash, null, "-"), __jsx(TimeLabelEnd, {
        adjustsFontSizeToFit: true,
        numberOfLines: 1
      }, __jsx(LocalizedTime, {
        parse: 'HH:mm',
        format: 'LT'
      }, this.props.endTime))));
    }
  }]);
  return OpeningHoursItem;
}(Component);
export { OpeningHoursItem as default };
var DayContainer = themed(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-direction: row\n  justify-content: space-between\n  padding-bottom: 10px\n"])));
var TimeContainer = themed(Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 0.5;\n  flex-direction: row\n  justify-content: flex-end\n"])));
var DayLabel = themed(Body1)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 0.5;\n  ", "\n"])), function (props) {
  return "color: ".concat(Theme(props).colors.homeScreen.subTitle);
});
var TimeLabelStart = themed(Body1)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0.5;\n  text-align: center;\n  ", "\n"])), function (props) {
  return "color: ".concat(Theme(props).colors.homeScreen.subTitle);
});
var TimeLabelEnd = themed(Body1)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 0.5;\n  text-align: center;\n  ", "\n"])), function (props) {
  return "color: ".concat(Theme(props).colors.homeScreen.subTitle);
});
var TimeDash = themed(Body1)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return "color: ".concat(Theme(props).colors.homeScreen.subTitle);
});